import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { MdVpnKey } from 'react-icons/md';
import { formatCount } from '../lib/bulk-password';

/**
 * Bar di atas tabel saat ada baris terpilih. Tidak merender apa pun bila
 * `count === 0`. Teks memakai rona biru (bukan abu) karena latarnya biru.
 *
 * @param {{
 *   count: number,
 *   entityLabel: string,
 *   pageRowCount: number,
 *   isPageFullySelected: boolean,
 *   totalFiltered: number,
 *   isAllFilteredSelected: boolean,
 *   isSelectingAll: boolean,
 *   onSelectAllFiltered: () => void,
 *   onClear: () => void,
 *   onChangePassword: () => void,
 * }} props
 */
function BulkSelectionBar({
  count,
  entityLabel,
  pageRowCount,
  isPageFullySelected,
  totalFiltered,
  isAllFilteredSelected,
  isSelectingAll,
  onSelectAllFiltered,
  onClear,
  onChangePassword,
}) {
  if (!count) return null;

  return (
    <Box
      role="region"
      aria-label="Pilihan massal"
      bg="blue.50"
      borderWidth="1px"
      borderColor="blue.100"
      borderRadius="md"
      px={4}
      py={2}
      mb={3}
      color="blue.900"
    >
      <Flex align="center" justify="space-between" flexWrap="wrap" gap={2}>
        <Flex align="center" flexWrap="wrap" columnGap={3} rowGap={1}>
          <Text fontWeight={600} aria-live="polite" sx={tabularNums}>
            {formatCount(count)} {entityLabel} dipilih
          </Text>
          <Button
            variant="link"
            size="sm"
            colorScheme="telegram"
            color="telegram.700"
            onClick={onClear}
          >
            Batalkan pilihan
          </Button>
        </Flex>
        {/* Nonaktif selama "pilih semua" memuat: pilihan masih berubah
            (mis. 10 -> 812), konfirmasi harus memuat jumlah yang final. */}
        <Button
          colorScheme="telegram"
          size="sm"
          leftIcon={<MdVpnKey aria-hidden="true" />}
          isDisabled={isSelectingAll}
          onClick={onChangePassword}
        >
          Ganti Password
        </Button>
      </Flex>
      <SelectAllNotice
        entityLabel={entityLabel}
        pageRowCount={pageRowCount}
        isPageFullySelected={isPageFullySelected}
        totalFiltered={totalFiltered}
        isAllFilteredSelected={isAllFilteredSelected}
        isSelectingAll={isSelectingAll}
        onSelectAllFiltered={onSelectAllFiltered}
      />
    </Box>
  );
}

const tabularNums = { fontVariantNumeric: 'tabular-nums' };

function SelectAllNotice({
  entityLabel,
  pageRowCount,
  isPageFullySelected,
  totalFiltered,
  isAllFilteredSelected,
  isSelectingAll,
  onSelectAllFiltered,
}) {
  const total = formatCount(totalFiltered);

  if (isAllFilteredSelected) {
    return (
      <Text fontSize="sm" mt={1} color="blue.800" sx={tabularNums}>
        Semua {total} {entityLabel} sesuai filter dipilih.
      </Text>
    );
  }
  if (!isPageFullySelected || totalFiltered <= pageRowCount) return null;

  return (
    <Flex
      fontSize="sm"
      mt={1}
      color="blue.800"
      align="center"
      flexWrap="wrap"
      columnGap={2}
      rowGap={1}
      sx={tabularNums}
    >
      <Text>
        Semua {formatCount(pageRowCount)} {entityLabel} di halaman ini dipilih.
      </Text>
      <Button
        variant="link"
        size="sm"
        colorScheme="telegram"
        color="telegram.700"
        isLoading={isSelectingAll}
        onClick={onSelectAllFiltered}
      >
        Pilih semua {total} {entityLabel} sesuai filter
      </Button>
    </Flex>
  );
}

export default BulkSelectionBar;
